import { API } from "aws-amplify";

export interface ModelUsageData {
  id: string;
  name: string;
  vendor: string;
  status: string;
  supported: boolean;
  inputTokenPrice: number;
  outputTokenPrice: number;
  defaultServiceGroup: string;
}

export interface ModelsUsageResponse {
  data: ModelUsageData[];
}

/**
 * Fetches models usage data from the LLM Public API
 * Uses the /models endpoint with fields="usage" parameter to get usage statistics
 *
 * @param projectId - The project ID (used for API key authentication)
 * @param apiKey - The API key for authentication
 * @returns Promise with models usage data including usage statistics
 */
export async function fetchModelsUsage(): Promise<ModelsUsageResponse> {
  try {
    const response = await API.get("llmpublicapi", "/models", {
      queryStringParameters: {
        fields: "usage",
      },
    });

    return { data: response };
  } catch (error) {
    console.error("Error fetching models usage:", error);
    throw error;
  }
}

export async function fetchModelsUsageWithContext(): Promise<ModelUsageData[]> {
  try {
    const response = await fetchModelsUsage();
    console.log("model response", response);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching models usage with context:", error);
    return [];
  }
}
